/* eslint-disable camelcase */
import {axios} from '../axios';
import {baseEnvironment} from '../environment/environment.base';
import { ResponseData,ConfigurationItem} from './service-mappers/BaseMapper';

const v1Version = baseEnvironment.apiVersion1;
const v3Version = baseEnvironment.apiVersion3;

const surgeryModalitiesUpperSsepRoute =
  `${v1Version}${baseEnvironment.apiEndPoints.upperSsep.upperSsep}`;
const surgeryModalitieseLowerSsepRoute =
  `${v1Version}${baseEnvironment.apiEndPoints.lowerSsep.lowerSsep}`;
const surgeryModalitiesUpperMep =
  `${v3Version}${baseEnvironment.apiEndPoints.upperMep.upperMep}`;
const surgeryModalitiesLowerMep =
  `${v3Version}${baseEnvironment.apiEndPoints.lowerMep.lowerMep}`;
const surgeryModalitiesTransabdominalMeps =
  `${v3Version}${baseEnvironment.apiEndPoints.transabdominalMeps.transabdominalMeps}`;
const surgeryModalitiesUpperEmg =
  `${v3Version}${baseEnvironment.apiEndPoints.upperEmg.upperEmg}`;
const surgeryModalitiesLowerEmg =
  `${v3Version}${baseEnvironment.apiEndPoints.lowerEmg.lowerEmg}`;
const surgeryModalitiesAbsAxialEmg =
  `${v1Version}${baseEnvironment.apiEndPoints.absAxialEmg.absAxialEmg}`;
const surgeryModalitiesCraniEmg =
  `${v3Version}${baseEnvironment.apiEndPoints.craniEmg.craniEmg}`;
const SurgeryModalitiesAnalSphincterEmg =
  `${v1Version}${baseEnvironment.apiEndPoints.anal.anal}`;
const SurgeryModalitiesUrethralSphincterEmg =
  `${v1Version}${baseEnvironment.apiEndPoints.urethral.urethral}`;
const SurgeryModalitiesBaepEmg =
  `${v1Version}${baseEnvironment.apiEndPoints.baep.baep}`;
const SurgeryModalitiesVepEmg =
  `${v1Version}${baseEnvironment.apiEndPoints.vep.vep}`;
const SurgeryModalitiesSnapEmg =
  `${v1Version}${baseEnvironment.apiEndPoints.snap.snap}`;
const SurgeryModalitiesHreflexEmg =
  `${v1Version}${baseEnvironment.apiEndPoints.hreflex.hreflex}`;
const SurgeryModalitiesMappingEmg =
  `${v1Version}${baseEnvironment.apiEndPoints.mapping.mapping}`;
const SurgeryModalitiesDssepEmg =
  `${v1Version}${baseEnvironment.apiEndPoints.dssep.dssep}`;
const SurgeryModalitiesEeg =
  `${v1Version}${baseEnvironment.apiEndPoints.eeg.eeg}`;
const SurgeryModalitiesOther =
  `${v1Version}${baseEnvironment.apiEndPoints.other.other}`;

const SurgeryModalitiesLateralApproachEmg =
  `${v1Version}${baseEnvironment.apiEndPoints.lateralApproach.lateralApproach}`;
const SurgeryModalitiesTriggreedEmg =
  `${v1Version}${baseEnvironment.apiEndPoints.triggreedEmg.triggreedEmg}`;
const SurgeryModalitiesThresholdTable =
  `${v1Version}${baseEnvironment.apiEndPoints.thresholdTable.thresholdTable}`;
const SurgeryModalitiesThresholdTableInsert =
  `${v1Version}${baseEnvironment.apiEndPoints.thresholdTableInsert.thresholdTableInsert}`;

const SurgeryModalitiesThresholdTableUpdate =
  `${v1Version}${baseEnvironment.apiEndPoints.thresholdTableUpdate.thresholdTableUpdate}`;

const leftAlert = `${v1Version}${baseEnvironment.apiEndPoints.leftAlert.leftAlert}`;

const rightAlert = `${v1Version}${baseEnvironment.apiEndPoints.rihtAlert.rightAlert}`;
const getLeftAlert = `${v1Version}${baseEnvironment.apiEndPoints.getLeftAlert.getLeftAlert}`;
const updateLeftAlert =
  `${v1Version}${baseEnvironment.apiEndPoints.updateLeftAlert.updateLeftAlert}`;
const getRightAlert = `${v1Version}${baseEnvironment.apiEndPoints.getRightAlert.getRightAlert}`;
const updateRightAlert =
  `${v1Version}${baseEnvironment.apiEndPoints.updateRightAlert.updateRightAlert}`;

const additionalAlertIssuedGet =
  `${v1Version}${baseEnvironment.apiEndPoints.additionalAlertIssuedGet.additionalAlertIssuedGet}`;

const additionalAlertIssueInsert =
  `${v1Version}${baseEnvironment.apiEndPoints.additionalAlertIssueInsert.additionalAlertIssueInsert}`;

const additionalAlertIssueUpdate =
  `${v1Version}${baseEnvironment.apiEndPoints.additionalAlertIssueUpdate.additionalAlertIssueUpdate}`;
const updateTo4Modality = `${v1Version}${baseEnvironment.apiEndPoints.updateTo4Modality.updateTo4Modality}`;
const getTo4Modality = `${v1Version}${baseEnvironment.apiEndPoints.getTo4Modality.getTo4Modality}`;
const uncheckAdditionalAlertIssueUpdate = `${v1Version}${baseEnvironment.apiEndPoints.uncheckAdditionalAlertIssueUpdate.uncheckAdditionalAlertIssueUpdate}`;
const deleteThresholdUrl = `${v1Version}${baseEnvironment.apiEndPoints.deleteThresholdEntry.deleteThresholdEntry}`;
const tEMG = `${v1Version}/${baseEnvironment.apiEndPoints.tEMG.tEMG}`;
const OtherModality = `${v1Version}/${baseEnvironment.apiEndPoints.surgeryModalities.otherModalities}`;

/* get surgery modalities upper ssep*/
export const getSurgeryModalitiesUpperSsep = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      surgeryModalitiesUpperSsepRoute + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesLowerSsep = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      surgeryModalitieseLowerSsepRoute + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesUpperMep = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      surgeryModalitiesUpperMep + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesLowerMep = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      surgeryModalitiesLowerMep + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const getSurgeryModalitiesTransabdominalMeps = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      surgeryModalitiesTransabdominalMeps + `/` + id,
      reqObject
    );
    // Online v3 API returns { statusCode, data: { ...fields } }; offline uses { result }.
    if (response?.data?.data && !response?.data?.result) {
      response.data.result = response.data.data;
    }
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesUpperEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      surgeryModalitiesUpperEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesLowerEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      surgeryModalitiesLowerEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesAbsAxialEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      surgeryModalitiesAbsAxialEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesCraniEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      surgeryModalitiesCraniEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesAnalSphincterEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesAnalSphincterEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesUrethralSphincterEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesUrethralSphincterEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesBaepEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesBaepEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesVepEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesVepEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesSnapEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesSnapEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesHreflexEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesHreflexEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesMappingEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesMappingEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesDssepEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesDssepEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getAndSetModalityEeg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesEeg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getAndSetModalityOther = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesOther + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesLateralApproachEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesLateralApproachEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesTriggeereedEmg = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesTriggreedEmg + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesThresholdTable = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesThresholdTable + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getSurgeryModalitiesThresholdTableInsert = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesThresholdTableInsert + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

// export const getSurgeryModalitiesThresholdTableUpdate = async (id: any, level: any, stim: any, reqObject: any): Promise<any> => {
//     try {
//         const response = await axios.post(SurgeryModalitiesThresholdTableUpdate + `/` + id + `/` + level + `/` + stim, reqObject);
//         return response
//     } catch (error) {
//         return error;
//     }
// };

export const getSurgeryModalitiesThresholdTableUpdate = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      SurgeryModalitiesThresholdTableUpdate + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const insertThresholdTableLeftAlert = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(leftAlert + `/` + id, reqObject);
    return response;
  } catch (error) {
    return error;
  }
};

export const insertThresholdTableRightAlert = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(rightAlert + `/` + id, reqObject);
    return response;
  } catch (error) {
    return error;
  }
};

export const getThresholdTableLeftAlert = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.get(getLeftAlert + `/` + id, reqObject);
    return response;
  } catch (error) {
    return error;
  }
};

export const upateThresholdTableLeftAlert = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(updateLeftAlert + `/` + id, reqObject);
    return response;
  } catch (error) {
    return error;
  }
};

export const getThresholdTableRightAlert = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.get(getRightAlert + `/` + id, reqObject);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateThresholdTableRightAlert = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(updateRightAlert + `/` + id, reqObject);
    return response;
  } catch (error) {
    return error;
  }
};

export const getAdditionalAlertIssued = async (
  id: any,
  modality: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.get(
      additionalAlertIssuedGet + `/` + id + `/` + modality,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const insertAdditionalAlertsIssued = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      additionalAlertIssueInsert + `/` + id,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const updateAdditionalAlertsIssued = async (
  id: any,
  modality: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      additionalAlertIssueUpdate + `/` + id + `/` + modality,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const uncheckAdditionalAlertsIssued = async (
  id: any,
  modality: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      uncheckAdditionalAlertIssueUpdate + `/` + id + `/` + modality,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getTo4Modalitity = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.get(
      getTo4Modality + `/` + id ,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const updateTo4Modalitity = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      updateTo4Modality + `/` + id ,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteThresholdEnrty = async (
  id: any,
  reqObject: any
): Promise<any> => {
  try {
    const response = await axios.post(
      deleteThresholdUrl + `/` + id ,
      reqObject
    );
    return response;
  } catch (error) {
    return error;
  }
};


export const gettEMG = async (): Promise<ResponseData<ConfigurationItem[]>> => {
    const response = await axios.get(`/${tEMG}`);
    return response.data; // returning only the data from the response
}

export const updatealltEMG = async(changedList:any,deletedIds:any): Promise<ResponseData<ConfigurationItem[]>> =>{
    const response = await axios.post(`/${tEMG}`,{changedList,deletedIds});
    return response.data;
}

export const getOtherModality = async (): Promise<ResponseData<ConfigurationItem[]>> => {
  const response = await axios.get(`/${OtherModality}`);
  return response.data; // returning only the data from the response
}

export const updateOtherModality = async(changedList:any,deletedIds:any): Promise<ResponseData<ConfigurationItem[]>> =>{
  const response = await axios.post(`/${OtherModality}`,{changedList,deletedIds});
  return response.data;
}

